import React from 'react';
import './TwoColumnLayout.scss';

interface TwoColumnLayoutProps {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  leftWidth?: string;
  rightWidth?: string;
  className?: string;
}

/**
 * TwoColumnLayout - A flexible two-column layout component
 * 
 * Usage examples:
 * 
 * 1. Text on left, stats on right (default):
 *    <TwoColumnLayout 
 *      leftContent={<p>Your text content here</p>}
 *      rightContent={<StatBlocks stats={statsData} />}
 *    />
 * 
 * 2. Chart on left, text on right:
 *    <TwoColumnLayout 
 *      leftContent={<BarChart data={data} />}
 *      rightContent={<p>Chart explanation text</p>}
 *    />
 * 
 * 3. Custom widths:
 *    <TwoColumnLayout 
 *      leftContent={<p>Narrow content</p>}
 *      rightContent={<p>Wide content</p>}
 *      leftWidth="30%"
 *      rightWidth="70%"
 *    />
 */
const TwoColumnLayout: React.FC<TwoColumnLayoutProps> = ({ 
  leftContent, 
  rightContent, 
  leftWidth = '',
  rightWidth = '',
  className = ''
}) => (
  <div className={`two-column-layout ${className}`}>
    <div className="left-column column" style={{ width: leftWidth }}>
      {leftContent}
    </div>
    
    <div className="right-column column" style={{ width: rightWidth }}>
      {rightContent}
    </div>
  </div>
);

export default TwoColumnLayout;
